import { useEffect, useState } from 'react';
import { useMyDataQuery } from '@/generated/graphql';
import {
  clipperFeatureNagSession,
  recordClipperFeatureNagAcknowledgement,
  shouldShowClipperFeatureNag,
  type ClipperFeatureNagDestination,
} from '@/lib/onboarding/clipperFeatureNagPreference';

function getLocalStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

/**
 * Shared click-time Clipadores nag orchestration for /earn (Acervo keeps the
 * page visible with blurred cards and never shows this nag) — see
 * clipperFeatureNagPreference.ts.
 * Both pages mounted their own copy of this open/dismiss state before this
 * extraction; keep behavior identical to avoid drift between the two.
 */
export function useClipperFeatureNag(destination: ClipperFeatureNagDestination) {
  const { data: myData, loading: myDataLoading } = useMyDataQuery();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (myDataLoading) return;

    setOpen(shouldShowClipperFeatureNag({
      storage: getLocalStorage(),
      session: clipperFeatureNagSession,
      objective: myData?.myData?.onboarding_objective ?? '',
      destination,
    }));
  }, [myData?.myData?.onboarding_objective, myDataLoading, destination]);

  const onContinue = (dismissAll: boolean) => {
    recordClipperFeatureNagAcknowledgement({
      storage: getLocalStorage(),
      session: clipperFeatureNagSession,
      destination,
      dismissAll,
    });
    setOpen(false);
  };

  return { open, onContinue };
}
